import React from "react";
import { Layout } from "antd";
import { Navigate } from "react-router-dom";
import Cookies from "universal-cookie";

const { Content } = Layout;
const cookies = new Cookies();

function BaseLayout({ children }) {
    const currentUser = cookies.get("userR");

    if (!currentUser && process.env.NODE_ENV === "production") {
        return <Navigate to={"/login"} replace />;
    }

    return (
        <Layout>
            <Content
                style={{
                    padding: "0",
                    background: "#fff",
                    minHeight: "100vh",
                }}
            >
                {children}
            </Content>
        </Layout>
    );
}

export default BaseLayout;